import Vue from 'vue'

Vue.component("nodata",{
    template: '<div style="display: flex; align-items: center;"><img style="width: 100%; " src="./static/images/nodata.png"/></div>'
});

Vue.component("pcnodata",{
    template: '<div style="display: flex; align-items: center; justify-content: center;"><img style="10em" src="./static/images/nodata.png"/></div>'
});




// WEBPACK FOOTER //
// ./src/components/common/simpleComponent.js